const $$splitComponentImporter = () => import('/Users/vthang/projects/marvy/marvy_mono/apps/pinktool/src/routes/_app/profile.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import type { UpdateProfileInputBody } from "@/api/types.gen";

// Allowed image extensions

export const Route = createFileRoute("/_app/profile")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});